import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, formDataPost, get, patch, post, put } from "helpers/api_helper"
import {
  GENERATE_CONTRACTS,
  GET_NOMINATED_CANDIDATES_FOR_CONTRACTS,
  GET_SIGNED_AND_UNSIGNED_CONTRACTS,
  GET_CONTRACT_BATCH_LIST,
  ALLOW_SIGNING_CONTRACTS_FOR_BATCH,
  GET_MY_CONTRACT,
  SIGN_THE_CONTRACT,
  ALLOW_SIGNING_CONTRACTS_FOR_SINGLE_CANDIDATE,
  RESET_CONTRACT,
} from "helpers/url_helper"

export const getNominatedCandidatesForContracts = createAsyncThunk(
  GET_NOMINATED_CANDIDATES_FOR_CONTRACTS,
  async payload => {
    const response = await post(GET_NOMINATED_CANDIDATES_FOR_CONTRACTS, payload)
    return response
  }
)

export const getSignedAndUnSignedCandidates = createAsyncThunk(
  GET_SIGNED_AND_UNSIGNED_CONTRACTS,
  async payload => {
    const response = await post(GET_SIGNED_AND_UNSIGNED_CONTRACTS, payload)
    return response
  }
)

export const generateContracts = createAsyncThunk(
  GENERATE_CONTRACTS,
  async payload => {
    const response = await post(GENERATE_CONTRACTS, payload)
    return response
  }
)
export const generateContractsFormData = createAsyncThunk(
  GENERATE_CONTRACTS,
  async payload => {
    const response = await formDataPost(GENERATE_CONTRACTS, payload)
    return response
  }
)

export const getContractBatchesList = createAsyncThunk(
  GET_CONTRACT_BATCH_LIST,
  async payload => {
    const response = await post(GET_CONTRACT_BATCH_LIST, payload)
    return response
  }
)

export const allowSigningContractsForBatch = createAsyncThunk(
  ALLOW_SIGNING_CONTRACTS_FOR_BATCH,
  async payload => {
    const response = await post(ALLOW_SIGNING_CONTRACTS_FOR_BATCH, payload)
    return response
  }
)
export const allowSigningContractsForSingleCandidate = createAsyncThunk(
  ALLOW_SIGNING_CONTRACTS_FOR_SINGLE_CANDIDATE,
  async payload => {
    const response = await post(
      ALLOW_SIGNING_CONTRACTS_FOR_SINGLE_CANDIDATE,
      payload
    )
    return response
  }
)

export const getMyContract = createAsyncThunk(
  GET_MY_CONTRACT,
  async payload => {
    const response = await post(GET_MY_CONTRACT, payload)
    return response
  }
)

export const signMyContract = createAsyncThunk(
  SIGN_THE_CONTRACT,
  async payload => {
    const response = await formDataPost(SIGN_THE_CONTRACT, payload)
    return response
  }
)

export const resetContract = createAsyncThunk(RESET_CONTRACT, async payload => {
  const response = await post(RESET_CONTRACT, payload)
  return response
})
